import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import classnames from 'classnames';
import PendingEmail from 'components/PendingEmail';
import {
  requestEmailChange,
  resendEmailChange,
  cancelEmailChange,
} from 'store/personalProfile/personalProfileOperations';
import ChangeEmailDialog from '../ChangeEmailDialog/ChangeEmailDialog';
import styles from './styles';

const useStyles = makeStyles(styles);

const EmailField = ({ openSnackbar }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.personalProfile.user?.profile);
  const pending = profile?.pendingEmail;
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const requestChange = async (email, currentPassword) => {
    await dispatch(requestEmailChange(email, currentPassword));
    setDialogOpen(false);
    openSnackbar({
      type: 'success',
      text: `We sent a confirmation link to ${email}. Your current email stays active until you confirm.`,
    });
  };

  const update = (operation, text) => async () => {
    setBusy(true);
    try {
      await dispatch(operation());
      openSnackbar({ type: 'success', text });
    } catch (err) {
      openSnackbar({ type: 'error', text: err.message });
    } finally {
      setBusy(false);
    }
  };

  const actionProps = (onClick) => ({
    variant: 'body1',
    color: busy ? 'textSecondary' : 'primary',
    style: { cursor: busy ? 'default' : 'pointer' },
    onClick: busy ? null : onClick,
  });

  return (
    <>
      <Grid item xs={12} lg={3}>
        <label htmlFor="email">
          <Typography variant="body1" color="textSecondary">
            Email:
          </Typography>
          <TextField
            type="text"
            id="email"
            value={profile?.email || ''}
            disabled
            variant="outlined"
            inputProps={{ 'aria-label': 'Email' }}
            fullWidth
          />
        </label>
        <Link component="button" type="button" variant="body1" onClick={() => setDialogOpen(true)}>
          Change email
        </Link>
        <PendingEmail pendingEmail={pending} />
      </Grid>
      {pending && (
        <Grid item xs={12} lg={3}>
          <div className={classnames('set-up-pass', classes.actions)}>
            <Typography {...actionProps(update(resendEmailChange, `We sent a new link to ${pending.email}.`))}>
              Resend
            </Typography>
            <Typography {...actionProps(update(cancelEmailChange, 'The email change was cancelled.'))}>
              Cancel
            </Typography>
          </div>
        </Grid>
      )}
      {isDialogOpen && (
        <ChangeEmailDialog onClose={() => setDialogOpen(false)} onSubmit={requestChange} />
      )}
    </>
  );
};

export default EmailField;
